import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Stack,
  Chip,
} from '@mui/material';
import {
  Timeline as TimelineIcon,
  ArrowForward as ArrowForwardIcon,
} from '@mui/icons-material';
import OrderDetailsModal from './OrderDetailsModal';

// Mock order data for testing progressive panels
const mockOrder = {
  id: 'ord-12345',
  orderNumber: 'ORD-2024-001',
  orderNumberNew: '25080001',
  customer: {
    name: 'John Doe',
    phone: '+1-555-0123',
    email: 'john.doe@example.com',
    address: '123 Main St, City, State 12345',
  },
  status: 'in_progress',
  priority: 'high',
  totalAmount: 15000,
  paymentStatus: 'partial',
  createdAt: '2024-01-15T10:30:00Z',
  products: [
    {
      id: 'prod-1',
      name: 'Custom Window Frame',
      type: 'Frame',
      description: 'Aluminum window frame with thermal break',
      total_items: 5,
      completed_items: 3,
      unit_price: 2500,
      quantity: 1,
      specifications: {
        material: 'Aluminum',
        dimensions: '1200x1500mm',
        color: 'White',
        finish: 'Anodized',
      },
      frame_items: [
        {
          id: 'item-1',
          qr_code: 'QR-FRAME-001',
          type: 'Frame',
          current_stage: 'Welding',
          current_stage_order: 3,
          status: 'in_progress',
          assigned_to: 'worker-001',
          supervisor_id: 'supervisor-001',
          started_at: '2024-01-15T11:00:00Z',
          completed_at: null,
          estimated_hours: 4,
          actual_hours: 2.5,
          quantity: 1,
          logs: [],
        },
        {
          id: 'item-2',
          qr_code: 'QR-FRAME-002',
          type: 'Frame',
          current_stage: 'Quality Check',
          current_stage_order: 4,
          status: 'completed',
          assigned_to: 'worker-003',
          supervisor_id: 'supervisor-001',
          started_at: '2024-01-15T09:00:00Z',
          completed_at: '2024-01-15T16:00:00Z',
          estimated_hours: 6,
          actual_hours: 7,
          quantity: 1,
          logs: [],
        },
      ],
      door_items: [],
      net_items: [],
      openable_type_items: [],
      panel_items: [
        {
          id: 'item-3',
          qr_code: 'QR-PANEL-001',
          type: 'Panel',
          current_stage: 'Coating',
          current_stage_order: 5,
          status: 'in_progress',
          assigned_to: 'worker-004',
          supervisor_id: 'supervisor-002',
          started_at: '2024-01-15T12:00:00Z',
          completed_at: null,
          estimated_hours: 3,
          actual_hours: 1.5,
          quantity: 2,
          logs: [],
        },
      ],
      panel_window_items: [],
    },
  ],
};

const ProgressivePanelTest: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Box sx={{ p: 3 }}>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Progressive Panel Test
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            This test demonstrates the progressive panel behavior where each panel slides in from the right and pushes previous panels to the left.
          </Typography>
          
          <Stack spacing={2} sx={{ mt: 3 }}>
            <Typography variant="h6">Panel Behavior:</Typography>
            <Box sx={{ pl: 2 }}>
              <Typography variant="body2" component="div">
                1. <strong>Products Panel (30%)</strong> - Slides in from right edge
              </Typography>
              <Typography variant="body2" component="div">
                2. <strong>Items Panel (30%)</strong> - Slides in from right, Products panel shifts left
              </Typography>
              <Typography variant="body2" component="div">
                3. <strong>Timeline Panel (30%)</strong> - Slides in from right, both panels shift left
              </Typography>
              <Typography variant="body2" component="div" sx={{ mt: 1, fontStyle: 'italic' }}>
                → Each new panel pushes previous panels towards the sidebar (left)
              </Typography>
            </Box>
            
            <Box sx={{ mt: 3 }}>
              <Button
                variant="contained"
                size="large"
                startIcon={<TimelineIcon />}
                onClick={() => setShowModal(true)}
                sx={{ px: 4, py: 1.5 }}
              >
                Test Progressive Panels
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>

      <OrderDetailsModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        order={mockOrder}
      />
    </Box>
  );
};

export default ProgressivePanelTest;
